// Test
// const RazorKey = "rzp_test_P6w1fgVOcHg5kK";
// const RazorSecret = "u6pUxilEZ81171VUzVWWGegD";

// Live
const RazorKey = "rzp_live_1KB8thAwKD0Zlm";
const RazorSecret = "MpeZb6N1Yn9aSgGE6Ot8XRNV";

export { RazorKey, RazorSecret }
